module.exports = __webpack_public_path__ + "img/剑花.637f0d12.jpg";